// @givmo/board — the helper line under a form field.
//
// The design-system's `TextField`/`Select` carry a label and an error row but no helper slot, so this
// is the one place the board app renders that line — consistently, rather than each form inventing its
// own margin and colour.
//
// It exists because several board fields NEED a sentence to be honest rather than merely tidy: the
// seat picker has to say the choice grants nothing, the citation field has to say it is required and
// why, and the time-zone picker has to say which clock the notice count is read in. A field that
// silently means something other than a volunteer assumes is the failure this component serves.

import type { ReactNode } from 'react';
import { testIdProp } from '@givmo/design-system';

export interface FieldNoteProps {
  children: ReactNode;
  testId?: string;
}

export function FieldNote({ children, testId }: FieldNoteProps) {
  return (
    <p
      className="-mt-8 font-sans text-s12 font-w400 leading-h15 tracking-givmo text-text-tertiary"
      {...testIdProp(testId)}
    >
      {children}
    </p>
  );
}
